export default {
    general: {
        add:            'Add',
        edit:           'Edit',
        cancel:         'Cancel',
        save:           'Save',
        close:          'Close',
        delete:         'Delete',
        confirm:        'Confirm',
        yes:            'Yes',
        no:             'No',
        search:         'Search',
        refresh:        'Refresh',
        retry:          'Retry',
        back:           'Back',
        copy:           'Copy',
        copied:         'Copied to clipboard',
        download:       'Download',
        open:           'Open',
        none:           'None',
        all:            'All',
        never:          'Never',
        unknown:        'Unknown',
        actions:        'Actions',
        name:           'Name',
        status:         'Status',
        loading:        'Loading…',
        no_data:        'No data',
        apply:          'Apply',
        clear:          'Clear',
        enabled:        'Enabled',
        disabled:       'Disabled',
        days:           'days',
        hours:          'hours',
        user:           'User',
        users:          'Users',
        project:        'Project',
        created:        'Created',
        updated:        'Updated',
        details:        'Details',
        optional:       'optional',
        of:             'of',
    },
    errors: {
        generic_error:         'Something went wrong',
        invalid_data:          'Some of the details are not right',
        not_found:             'This is no longer available',
        unauthorized:          'You are not signed in',
        forbidden:             'You are not allowed to do this',
        conflict:              'This cannot be done right now — refresh the page and try again',
        no_capacity:           'The server has no room for another workspace right now',
        upstream_failure:      'Something Startbox needs did not answer — please try again in a moment',
        incus_unavailable:     'The server is not ready right now — please try again in a moment',
        gone:                  'This link is no longer available',
        no_hostname_available: 'No web address is free right now — please try again in a few minutes',
        instance_type_limit:   'You already run the maximum number of workspaces of this type.',
        image_preparing:       'The workspace image is being prepared — this takes a few minutes.',
        kvm_unavailable:       'This workspace size needs virtualisation, which this server does not have.',
        failed_to_insert:      'Could not be saved',
        on_add:                'Could not be added',
        on_edit:               'Could not be saved',
        on_delete:             'Could not be deleted',
        on_load:               'Could not be loaded',
        rate_limited:          'Too many tries — please wait a moment and try again',
        // One plain sentence per `state_reason` the plane can put on a failed environment
        // (technical design §3.3). The user of Startbox is not a developer: the technical
        // text sits under this line, and only an admin is ever sent it. An unknown code
        // falls back to `unknown`, so an older SPA against a newer plane still says
        // something true.
        state: {
            incus_unavailable: 'The server is not ready right now. Try again in a moment.',
            image_unavailable: 'The workspace image is not available right now.',
            no_capacity:       'The server has no room for this workspace right now.',
            timeout:           'This took too long and was stopped. Try again.',
            volume_failed:     'The workspace storage could not be prepared.',
            create_failed:     'The workspace could not be created. Try again.',
            config_failed:     'The workspace could not be set up. Try again.',
            netbird_failed:    'The private network did not let this workspace in.',
            start_failed:      'The workspace did not start. Try again.',
            stop_failed:       'The workspace did not stop.',
            delete_failed:     'The workspace could not be deleted.',
            disk_pressure:     'Stopped because the server ran out of disk space.',
            unknown:           'Starting failed. Try again.',
        },
    },
    success: {
        add:    'Successfully added',
        edit:   'Successfully updated',
    },
    validation: {
        required:    'This field is required',
        email:       'Invalid email address',
        signin_code: 'Paste the code Claude showed you, with no spaces',
        min_search:  'Type at least 2 characters',
        positive:    'The value must be greater than zero',
    },
    app: {
        name:    'Startbox',
    },
    layout: {
        open_menu:  'Open menu',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    nav: {
        home:         'Home',
        workspaces:   'Workspaces',
        settings:     'Settings',
        admin:        'Administration',
        host:         'Host',
        environments: 'Environments',
        hostnames:    'Public addresses',
        tls:          'TLS',
        users:        'Users',
        audit:        'Audit log',
        platform:     'Platform',
        logout:       'Sign out',
    },
    login: {
        title:        'Sign in to Startbox',
        subtitle:     'Use your GitLab account to continue.',
        sign_in:      'Sign in with GitLab',
        failed:       'Sign-in failed. Please try again.',
        signing_in:   'Signing you in…',
        // The `?error=` codes the plane's /auth/callback redirects with.
        error_state:    'That sign-in link is no longer valid — it was opened twice, or it sat too long. Please sign in again.',
        error_exchange: 'GitLab would not confirm this sign-in. Please sign in again.',
        error_gitlab:   'GitLab could not be reached to finish the sign-in. Please try again in a moment.',
        error_session:  'Startbox could not finish the sign-in. Please try again — if it keeps failing, tell your administrator.',
    },
    home: {
        title:             'Home',
        running:           'Running',
        running_empty:     'No environment is running right now.',
        see_all_workspaces: 'See all workspaces',
        groups_view:       'Groups',
        projects_view:     'Projects',
        refresh:           'Refresh from GitLab',
        refresh_success:   'Projects refreshed from GitLab',
        refresh_limited:   'Refreshed recently — please wait a moment before refreshing again',
        search_placeholder: 'Search projects…',
        no_projects:       'No projects',
        no_groups:         'No groups',
        all_groups:        'All groups',
        subgroups:         'Subgroups',
        projects:          'Projects',
        project_count:     '{count} projects',
        last_fetched:      'Last refreshed {time}',
        load_error:        'The project list could not be loaded.',
        warming:           'Loading your projects from GitLab…',
        // Admins only: the person who wanted to open a project can do nothing about a full
        // disk, and telling them would only make them doubt their work is safe.
        disk_warning:      'The server is running out of disk space.',
        // Admins only, for the same reason: a build nobody but an operator can retry.
        image_warning:     'The new workspace image could not be built.',
    },
    project: {
        default_branch:    'Default branch',
        start:             'Start',
        stop:              'Stop',
        reset:             'Reset',
        delete:            'Delete',
        console:           'Console',
        open_workspace:    'Open workspace',
        advanced:          'Advanced',
        never_started:     'Not started yet',
        limits:            '{cpu} vCPU · {memory} RAM',
        last_heartbeat:    'Last heartbeat {time}',
        read_only_warning: 'You can only read this project, so changes cannot be pushed back.',
        drift:             'Settings changed',
        drift_fix:         'Fix',
        drift_fixed:       'A fix was requested — the environment will apply it shortly',
        delete_after:      'Will be deleted in {count} day | Will be deleted in {count} days',
        delete_after_soon: 'Will be deleted today',
        state_message:     'Reason: {message}',
        signin_title:      'Sign in to Claude',
        signin_open:       'Sign in to Claude',
        signin_code:       'Sign-in code',
        signin_submit:     'Send code',
        signin_sent:       'Code sent to the environment',
        signin_waiting:    'Code sent — waiting for the environment (usually 10 s)…',
        signin_typing:     'Signing in to Claude…',
        signin_success:    'Signed in',
        signin_failed:     'Sign-in failed',
        signin_restart:    'Request a new sign-in link',
        signin_restarted:  'A new sign-in link was requested — it appears here shortly',
        confirm_stop:      'Stop this workspace? Your work is saved first.',
        confirm_reset:     'Rebuild this workspace from scratch? Your work is saved first.',
        confirm_delete:    'Delete this workspace? Your work is saved first.',
        started:           'The environment is starting',
        stopping:          'The environment is stopping',
        resetting:         'The environment is being reset',
        deleting:          'The environment is being deleted',
        deleted:           'The environment was deleted',
        pending:           'Working…',
        state: {
            stopped:          'Stopped',
            starting:         'Starting',
            needs_signin:     'Sign in needed',
            running:          'Running',
            running_outdated: 'Running',
            error:            'Problem',
        },
        update_available:  'An update is installed the next time you start this workspace.',
    },
    share: {
        auth_sso:      'GitLab sign-in',
        auth_pin:      'PIN',
        auth_password: 'Password',
        auth_none:     'No authentication',
    },
    backup: {
        title:          'Backups ({count})',
        expires_in:     'expires in {count} day | expires in {count} days',
        expires_today:  'expires today',
        no_expiry:      'kept',
        restored:       'restored',
        keep:           'Keep',
        kept:           'The backup will be kept',
        deleted:        'The backup was deleted',
        confirm_delete: 'Delete this backup? It cannot be brought back.',
        warn_count:     '{count} backup will be removed soon | {count} backups will be removed soon',
    },
    access: {
        only_me:              'Only you',
        people:               'Specific people',
        company:              'Everyone in the company',
        link:                 'Anyone with the link',
        pin:                  'With PIN',
        password:             'With password',
        add_person:           'Add a person…',
        pin_placeholder:      '4–12 digits',
        password_placeholder: 'At least 8 characters',
        keep:                 'Keep',
        no_expiry:            'Does not expire',
        expires_in:           'Expires in {hours} h',
        remove_link:          'Remove link',
        workspace_people:     'People with access',
    },
    environment: {
        title:               'Workspace',
        list_title:          'Your workspaces',
        list_empty:          'No workspaces yet.',
        activity:            'Last activity',
        active_since:        'Active {time}',
        stopped_ago:         'Stopped {time}',
        available_in_claude: 'Available in Claude',
        owned_by:            'Owned by {user}',
        app_count:           '{count} apps',
        instance:            'Instance',
        dirty:               'Uncommitted changes',
        last_backup:         'Last backup',
        limits:              'Limits',
        volumes:             'Volumes',
        volumes_value:       'Workspace {ws} · Home {home}',
        last_heartbeat:      'Last heartbeat',
        plugins:             'Plugins',
        plugins_value:       'Plugins: {list}',
        docker_prune_value:  'Docker prune: {bytes} freed {when}',
        state_message:       'State message',
        apps:                 'Running apps',
        apps_empty:           'No apps running',
        apps_stopped:         'Workspace is not running',
        apps_stale:           'Not running',
        usage: {
            cpu:           'CPU',
            ram:           'RAM',
            workspace:     'Workspace',
            home:          'Home',
            cores:         '{count} vCPU',
            system:        'System',
            disk:          'Disk',
            network_total: '{rx} / {tx} total',
        },
        // The history card under the usage strip. Chart titles and legend keys — no sentence
        // explains a chart here any more than one explains a bar above it.
        metrics: {
            title:   'Usage',
            network: 'Network',
            used:    'Used',
            limit:   'Limit',
            rx:      'Down',
            tx:      'Up',
        },
    },
    console: {
        title:        'Console',
        connecting:   'Connecting…',
        connected:    'Connected',
        closed:       'The connection was closed.',
        error:        'The connection failed.',
        reconnect:    'Reconnect',
        not_running:  'The workspace must be started to open the console.',
    },
    changes: {
        title:         'Changes',
        files_changed: '{count} files changed',
        staged:        'Staged',
        binary:        'Binary file',
        clean:         'No changes',
        not_running:   'The workspace must be started to read its changes.',
        load_failed:   'Could not load changes',
        download:      'Download full diff',
    },
    files: {
        title:          'Files',
        root:           'Workspace',
        empty:          'Empty folder',
        not_running:    'The workspace must be started to browse files.',
        truncated:      'Only the first 500 entries are shown.',
        upload:         'Upload',
        upload_success: '{count} file uploaded | {count} files uploaded',
        upload_failed:  'The file could not be uploaded.',
        download:       'Download',
        copy_path:      'Copy path',
        too_large:      'This file is too large to preview.',
        no_preview:     'This file cannot be previewed.',
        preview_failed: 'The file could not be opened.',
        load_failed:    'Could not open this folder',
    },
    settings: {
        title:        'Settings',
        appearance:   'Appearance',
        color_mode:   'Theme',
        language:     'Language',
        language_en:  'English',
        language_sl:  'Slovenščina',
        home_view:    'Default home view',
        home_groups:  'Groups',
        home_projects: 'Projects',
        saved:        'Settings saved',
        account:      'Account',
        admin_badge:  'Administrator',
        netbird: {
            title:      'Private network',
            linked:     'Your NetBird account is linked',
            not_linked: 'Your NetBird account is not linked yet',
        },
        ssh_key: {
            title: 'SSH key',
        },
    },
    claude_account: {
        title:            'Claude accounts',
        add:              'Add account',
        label:            'Name',
        default:          'Default',
        set_default:      'Use by default',
        rename:           'Rename',
        empty:            'No accounts yet.',
        start_with:       'Start with',
        one:              'Claude account',
        confirm_delete:   'Remove {label}?',
        name_taken:       'That name is already used',
        deleted:          'The account was removed',
        delete_conflict:  'This account cannot be removed — make another account the default first',
    },
    instance_type: {
        title:         'Instance type',
        choose:        'Choose an instance type',
        // The heading of the one dialog a start raises when it has both questions to ask.
        start_title:   'Start the workspace',
        change:        'Change instance type',
        summary:       '{cpu} vCPU · {memory} · {ws}',
        changed:       'The instance type was changed',
        limit_reached: 'This instance type is already full',
        // Hardware virtualisation. One word on a chip, and a sentence only where there is
        // room for it — a tooltip on the workspace page.
        kvm:           'KVM',
        no_kvm:        'No KVM',
        kvm_note:      'This workspace can run virtual machines and emulators.',
    },
    // The environment image the plane builds for itself. Every signed-in user reads this
    // much of it (GET /image): the Start buttons are off while it is being prepared, and
    // the card that says so carries nothing but the step and the bar.
    image: {
        preparing: 'Preparing the workspace image',
        step: {
            create_instance: 'Preparing the build machine',
            install_tools:   'Installing the build tools',
            push_inputs:     'Copying the recipe',
            build:           'Building the image',
            pull:            'Collecting the image',
            import:          'Importing the image',
            smoke_test:      'Test-starting the image',
            verify:          'Checking the image',
            swap:            'Switching to the new image',
            cleanup:         'Cleaning up',
        },
        status: {
            none:      'No image yet',
            building:  'Building',
            succeeded: 'Ready',
            failed:    'Build failed',
            skipped:   'Build skipped',
        },
    },
    admin: {
        title:              'Administration',
        settings:           'Instance settings',
        audit:              'Audit log',
        host: {
            title:             'Host status',
            incus_reachable:   'Incus reachable',
            incus_unreachable: 'Incus unreachable',
            incus_version:     'Incus {version}',
            ram:               'RAM',
            pool:              'Storage pool',
            cpu:               'CPU',
            usage:             '{used} of {total} used',
            free:              '{free} free',
            // Numbers only, like every other tile on this page: the reader of an
            // infrastructure screen knows what a load average is.
            cores:             '{count} vCPU',
            load:              'Load {load}',
            running:           'Running environments',
            kvm:               'Virtualisation',
            kvm_available:     'Available',
            kvm_unavailable:   'Not available',
            // The numbers the start-admission rule is decided on. No explanatory line under
            // them: this is the one screen whose reader already knows what they mean.
            committed:         'Committed quotas',
            committed_limit:   'Overcommit ceiling',
            overcommit:        'Overcommit factor',
            footprint:         'New workspace footprint',
            headroom:          'Disk headroom',
            critical:          'Critical below',
            pressure_low:      'Low disk space',
            pressure_critical: 'Critically low disk space',
            checked:           'Checked {time}',
            load_error:        'The host status could not be loaded.',
            // The history card. Labels and units only, like the tiles above it.
            metrics_title:     'Usage',
            metrics_used:      'Used',
            metrics_total:     'Total',
            load_title:        'Load',
            load_1:            '1 min',
            load_5:            '5 min',
            load_15:           '15 min',
        },
        environments: {
            open:           'Open workspace',
            state:          'State',
            user:           'User',
            search:         'Search',
            last_heartbeat: 'Last heartbeat',
            no_items:       'No environments.',
            total_ram:      'RAM in use',
            total_disk:     'Disk used',
            running_count:  '{count} running',
        },
        users: {
            username:          'Username',
            email:             'E-mail',
            environments:      'Environments',
            last_login:        'Last sign-in',
            limits:            'Limits',
            limits_default:    'Defaults',
            limits_title:      'Limits for {user}',
            custom_home:       'Custom home volume',
            home:              'Home volume (GB)',
            types:             'Instance types',
            types_title:       'Instance types for {user}',
            types_default:     'Defaults',
            types_is_default:  'Default',
            types_max_running: 'Workspaces at once',
            types_saved:       'Instance types saved',
            cleared:           'The override was cleared',
            saved:             'Limits saved',
            no_users:          'No users.',
            admin:             'Administrator',
        },
        instance_types: {
            title:          'Instance types',
            add:            'Add instance type',
            edit_title:     'Edit instance type',
            name:           'Name',
            cpu:            'vCPU',
            memory:         'RAM (GB)',
            ws:             'Workspace (GB)',
            max_running:    'Workspaces at once',
            unlimited:      'Unlimited',
            default:        'Default',
            set_default:    'Set as default',
            no_items:       'No instance types.',
            in_use:         'This instance type is in use and cannot be deleted',
            saved:          'The instance type was saved',
            deleted:        'The instance type was deleted',
            confirm_delete: 'Delete {name}?',
            apply_failed:   'The new size could not be applied to {count} running workspace | The new size could not be applied to {count} running workspaces',
            name_taken:     'That name is already used',
        },
        settings_form: {
            defaults:                  'Environment defaults',
            retention:                 'Retention',
            exposure:                  'Sharing defaults',
            language:                  'Language',
            home:                      'Home volume (GB)',
            idle_stop_hours:           'Stop idle environments after (hours)',
            auto_delete_days:          'Delete stopped environments after (days)',
            backup_branch_keep:        'Backup branches kept per project',
            home_export_keep:          'Home backups kept per user',
            exposure_auth:             'Default authentication for public links',
            exposure_ttl:              'Public links expire after (hours)',
            hostname_pool_mode:        'Public address mode',
            hostname_pool_target:      'Free public addresses kept ready',
            default_language:          'Default UI language',
            claude_code:               'Claude Code',
            claude_code_auto_update:   'Update Claude Code when an environment starts',
            saved:                     'Settings saved',
        },
        plugins: {
            title:              'Claude Code plugins',
            marketplaces:       'Marketplaces',
            add_marketplace:    'Add marketplace',
            name:               'Name',
            source:             'Source',
            source_git:         'Git repository',
            source_github:      'GitHub repository',
            source_url:         'Direct marketplace.json URL',
            url:                'URL',
            repo:               'Repository (owner/repo)',
            enabled:            'Enabled plugins',
            enabled_placeholder: 'Pick or type plugin{\'@\'}marketplace',
            fetch_failed:       'The marketplace could not be read',
            enforcement:        'Enforcement',
            enforce:            'Enforce this policy',
            invalid_name:       'Letters, digits, dots, dashes and underscores only.',
            invalid_url:        'This does not match the selected source: a GitHub source wants owner/repo, a direct URL wants https://, and a git source wants an HTTPS or git{\'@\'}host:path.git URL.',
            reserved_name:      'This name belongs to one of Anthropic\'s own marketplaces; plugins from it need no entry here.',
            invalid_plugin:     'Write the plugin as plugin{\'@\'}marketplace.',
            saved:              'The plugin policy was saved',
        },
        hostnames: {
            title:            'Public addresses',
            manage:           'Manage addresses',
            on_demand:        'Addresses are created on demand',
            hostname:         'Address',
            source:           'Source',
            source_generated: 'Generated',
            source_manual:    'Manual',
            mode:             'Address mode of this instance',
            add:              'Add hostnames',
            add_label:        'Hostnames',
            add_placeholder:  'demo.example.com\napp.example.com',
            created:          '{count} added',
            result_created:   'Added',
            result_errors:    'Rejected',
            state:            'State',
            exposure:         'Used by',
            assigned:         'Assigned',
            cooldown:         'Cooldown ends',
            last_auth:        'Last authentication',
            target:           'Target free',
            created_last_7d:  'Created in the last 7 days',
            weekly_budget:    'Weekly budget',
            state_free:       'Free',
            state_assigned:   'In use',
            state_reserved:   'Reserved',
            state_cooling:    'Cooling down',
            release:          'Release',
            release_confirm:  'Release {name}? It stops being kept for {owner} and goes into cooling, after which it can be handed to someone else.',
            released:         'The address was released',
            retire:           'Retire',
            retire_confirm:   'Retire {name}? It is taken out of the pool for good and will never be handed out again.',
            retired:          'The address was retired',
            no_items:         'No addresses.',
        },
        tls: {
            title:                    'TLS and certificates',
            manage:                   'Manage TLS',
            settings:                 'TLS settings',
            certificates:             'Certificates',
            load_error:               'The TLS settings could not be loaded.',
            saved:                    'TLS settings saved',
            mode:                     'TLS mode',
            mode_external:            'Terminated in front of the panel',
            mode_panel:               'Terminated by the panel',
            cert_mode:                'Certificate mode',
            cert_per_hostname:        'One certificate per hostname',
            cert_wildcard_acme:       'Wildcard over DNS-01',
            cert_wildcard_files:      'Wildcard you upload',
            wildcard_files_missing:   'A wildcard certificate has to be uploaded',
            acme:                     'ACME account',
            acme_email:               'Account e-mail',
            directory:                'Directory',
            directory_production:     'Let’s Encrypt production',
            directory_staging:        'Let’s Encrypt staging (testing)',
            directory_custom:         'Custom directory URL',
            directory_url:            'Directory URL',
            directory_url_invalid:    'Enter the https:// URL of an ACME directory',
            dns:                      'DNS-01 challenge',
            dns_provider:             'DNS provider',
            dns_provider_none:        'None',
            dns_provider_httpreq:     'httpreq (HTTP request)',
            dns_provider_required:    'A wildcard ordered over DNS-01 needs a DNS provider',
            dns_config:               'Provider settings',
            dns_config_key:           'Key',
            dns_config_value:         'Value',
            dns_config_masked:        'Hidden — type to replace',
            dns_config_add:           'Add setting',
            dns_config_remove:        'Remove',
            dns_config_restore:       'Keep',
            dns_config_empty:         'No provider settings yet.',
            plane_host:               'Panel address',
            summary_valid:            'Valid',
            summary_pending:          'Pending',
            summary_error:            'Failed',
            summary_expiring:         'Expiring in 30 days',
            name:                     'Primary name',
            names:                    'Names',
            kind:                     'Kind',
            kind_acme:                'ACME',
            kind_uploaded:            'Uploaded',
            kind_self_signed:         'Self-signed',
            status_valid:             'Valid',
            status_pending:           'Pending',
            status_error:             'Failed',
            expires:                  'Expires',
            issued:                   'Issued',
            next_attempt:             'Next attempt {time}',
            last_error:               'Last error',
            renew:                    'Renew',
            renew_confirm:            'Renew the certificate for {name} now? A certificate authority counts every order against a rate limit.',
            renew_requested:          'A renewal was requested',
            renew_only_acme:          'Only a certificate the panel ordered can be renewed',
            wildcard_needs_generated: 'A wildcard certificate only covers generated addresses — switch the certificate mode first, or use per-hostname certificates',
            delete_confirm:           'Delete the uploaded certificate for {name}? It stops being served immediately.',
            deleted:                  'The certificate was deleted',
            delete_conflict:          'Only an uploaded certificate can be deleted — the panel manages the others itself.',
            delete_only_uploaded:     'Only an uploaded certificate can be deleted',
            upload:                   'Upload certificate',
            upload_cert:              'Certificate chain (PEM)',
            upload_cert_placeholder:  '-----BEGIN CERTIFICATE-----',
            upload_key:               'Private key (PEM)',
            upload_key_placeholder:   '-----BEGIN PRIVATE KEY-----',
            upload_invalid:           'This does not look like PEM — it has to start with -----BEGIN',
            uploaded:                 'The certificate was uploaded',
            no_items:                 'No certificates.',
        },
        netbird: {
            title:       'NetBird',
            reachable:   'Management reachable',
            unreachable: 'Management unreachable',
            peers:       'Peers',
            checked:     'Checked {time}',
            disabled:    'NetBird is disabled on this instance',
        },
        image: {
            title:          'Workspace image',
            built:          'Built',
            agent_version:  'Agent',
            claude_version: 'Claude Code',
            previous:       'Previous',
            no_image:       'No image has been built yet',
            build:          'Build new',
            build_started:  'The image build has started',
            revert:         'Revert to previous image',
            revert_confirm: 'Go back to image {version}?',
            reverted:       'The previous image is current again',
            failed:         'The last build failed',
            skipped:        'The last build was skipped',
            log:            'Log',
            log_title:      'Build log',
            log_empty:      'The build left no log',
            truncated:      'Only the end of the log is kept',
        },
        audit_log: {
            at:      'Time',
            actor:   'Actor',
            action:  'Action',
            target:  'Target',
            ip:      'IP',
            details: 'Details',
            from:    'From',
            to:      'To',
            no_events: 'No audit events.',
        },
    },
    create: {
        new_project:       'New project',
        new_group:         'New group',
        name:              'Name',
        location:          'Location',
        parent:            'Parent group',
        top_level:         'No parent group',
        personal:          'Personal',
        create:            'Create',
        create_group:      'Create group',
        created:           'Project created',
        group_created:     'Group created',
        nowhere:           'You cannot create projects anywhere in GitLab. Ask your GitLab administrator.',
        project_forbidden: 'You cannot create projects here.',
        group_forbidden:   'You cannot create groups here.',
        name_taken:        'This name is already taken here.',
        name_invalid:      'Use letters, numbers, spaces, dots, dashes or underscores.',
        open_gitlab:       'Open in GitLab',
    },
    starter: {
        button: 'Starter prompt',
        prompt: 'I work in Startbox ({startbox_url}). Every project of mine is in GitLab ({gitlab_url}) and gets its own workspace with Claude Code, which I reach from the Claude app. I am not a developer: do the technical work for me and explain only what I need to decide. I want to ',
    },
    guide: {
        title:         'Guide',
        heading:       'Working with Startbox',
        download_pdf:  'Download PDF',
        preview:       'Preview',
        client_name:   'Client name',
        contact:       'Contact',
        contact_hint:  'Who to ask for help: name, e-mail, phone',
        starter_title: 'Starter prompt',
        help_title:    'Help',
        sign_in: {
            title: 'Sign in',
            open:  'Open {url}',
            press: 'Press "Sign in with GitLab" and use your GitLab account ({url}).',
        },
        start: {
            title:  'Start a project',
            find:   'On Home, find your project — or press "New project" to make one.',
            press:  'Press "Start". The workspace is ready in about a minute.',
            claude: 'The first time only: press "Sign in to Claude", sign in with your Claude account, then paste the code it shows into Startbox.',
        },
        connect: {
            title:   'Connect Claude',
            install: 'Install the Claude app on your computer or phone and sign in with the same Claude account.',
            open:    'Open "Code" in the Claude app. Your workspace is listed under the project\'s name.',
            ready:   'When the project on Home says "Available in Claude", tell Claude what you want.',
        },
        where: {
            title:      'Where things are',
            workspaces: '"Workspaces" lists every workspace you have.',
            apps:       '"Running apps" on a workspace shows what Claude built; "Open" shows it in the browser.',
            files:      '"Files" lets you browse, download and upload files.',
            changes:    '"Changes" shows what Claude changed in the project.',
            gitlab:     'Your work is kept in GitLab ({url}).',
        },
        done: {
            title: 'When you are done',
            stop:  'Press "Stop", or just leave it: an unused workspace stops on its own. Your work is saved first.',
        },
    },
    not_found: {
        title:    'Page not found',
        subtitle: 'The page you are looking for does not exist.',
        home:     'Back to home',
    },
}
